var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"events-feed events-feed--small"},[_c('results',{attrs:{"has-carousel":_vm.hasCarousel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }